// extracted by mini-css-extract-plugin
module.exports = {"box":"ContentScroll_box__1Ls-P","box2":"ContentScroll_box2__2idj6"};